import { Injectable, NgZone } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../../app/shared/components/snackbar/snackbar.component';
import { SnackBarType } from '../../types/enums';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    public snackbar: MatSnackBar,
    private zone: NgZone,
    private translateService: TranslateService
  ) {}

  error(message: string, duration: number = 4000) {
    const config = new MatSnackBarConfig();
    config.duration = duration;
    this.zone.run(() => {
      this.snackbar.openFromComponent(SnackbarComponent, {
        ...config,
        data: { type: SnackBarType.ERROR, message },
      });
    });
  }

  success(message: string, duration: number = 4000) {
    const config = new MatSnackBarConfig();
    config.duration = duration;
    config.panelClass = ['success-snackbar'];
    this.zone.run(() => {
      this.snackbar.openFromComponent(SnackbarComponent, {
        ...config,
        data: { type: SnackBarType.SUCCESS, message },
      });
    });
  }

  withAction(
    message: string,
    action: string,
    duration: number = 60000,
    panelClass: string[] = []
  ): MatSnackBarRef<TextOnlySnackBar> {
    return this.zone.run(() =>
      this.snackbar.open(message, action, {
        duration,
        verticalPosition: 'bottom',
        panelClass,
      })
    );
  }

  successCart() {
    const config = new MatSnackBarConfig();
    config.duration = 1000;
    config.panelClass = ['success-snackbar', 'cart-success'];
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'left';

    // .get() (unlike .instant()) waits for the translations to finish
    // loading rather than echoing the raw key back if called before the
    // language file has loaded.
    this.translateService.get('cart.success.cartSaved').subscribe(message => {
      this.zone.run(() => {
        this.snackbar.open(message, '', config);
      });
    });
  }
}
